import cns from 'classnames'

import { Text } from 'shared/ui/common/Text'

import s from './NFCSMintImprove.module.scss'

type Props = {
  className?: string
}

export function NFCSMintImprove({ className }: Props) {
  return (
    <div className={cns(s.wrap, className)}>
      <div className={s.item}>
        <div className={s.number}>1</div>
        <Text size={16} weight={600} isUppercased isCentered color="secondary">
          <Text tag="span" color="default">
            Connecting multiple wallets
          </Text>{' '}
          Preferably with at&nbsp;least 200 days of history
        </Text>
      </div>

      <div className={s.item}>
        <div className={s.number}>2</div>
        <Text size={16} weight={600} isUppercased isCentered color="secondary">
          <Text tag="span" color="default">
            Interacting with DeFi protocols
          </Text>{' '}
          including DEXs, Lending, Yield Farming, and Governance
        </Text>
      </div>

      <div className={s.item}>
        <div className={s.number}>3</div>
        <Text size={16} weight={600} isUppercased isCentered color="secondary">
          Connecting
          <br />
          <Text tag="span" color="default">
            DID
          </Text>{' '}
          and{' '}
          <Text tag="span" color="default">
            Social Graph
          </Text>
        </Text>
      </div>
    </div>
  )
}
